import styled from "styled-components";

export const AuthenticationContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  button:focus {
    border: 2px solid #8fbdff;
  }
`;

export const LoggedInNotify = styled.div`
  background-color: #e4d44b;
`;

export const CallbackContainerStyled = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: "Red Hat Display", sans-serif;
  color: #0f1731;
`;

export const CallbackTitleStyled = styled.h2`
  font-size: 28px;
  margin-bottom: 16px;
`;

export const CallbackMessageStyled = styled.p`
  font-size: 14px;
  color: #868a97;
  margin-bottom: 24px;
`;

export const CallbackButtonStyled = styled.button`
  color: rgb(255, 255, 255);
  font-family: "Red Hat Display", sans-serif;
  background-color: rgb(76, 136, 255);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  cursor: pointer;
  font-size: 14px;
  height: 40px;
  border: 2px solid transparent;
  transition: all 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.5;
  }
`;
